import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import styles from './PdpRespPreviewMessageBanner.scss';

function launchPrintDialogue() {
    if (typeof window !== 'undefined') {
        window.print();
    }
}

function PdpRespPreviewMessageBanner() {
    return (
        <div className={styles.banner}>
            <div className={styles.message}>
                <FormattedMessage
                    id="PdpRespPreviewMessageBanner.banner"
                    defaultMessage="You’re viewing a work in progress. This page will be fully translated into the buyer’s preferred language. <printCTA>Click here to print.</printCTA>"
                    values={{
                        printCTA: text => (
                            <Link
                                onClick={launchPrintDialogue}
                                className={`${styles.printLink} enable-click-on-preview`}
                            >
                                {text}
                            </Link>
                        ),
                    }}
                />
            </div>
        </div>
    );
}

export { PdpRespPreviewMessageBanner };
